import {
  MarkerType,
  getMarkerFormattersHTML,
  markerFormattersURL,
} from '@apps/main/modules/maps/markerFormatters';

import { AccommodationType } from '@libs/trip-planner-interfaces';
import type { MapTypeId, Marker, MarkerFormatter, Rectangle } from '@libs/maps';

import type { ActivityStaticData } from '../models';
import { MapType } from '../../maps';

export function getInitialMapView(
  activityDetails: ActivityStaticData | undefined
): Rectangle | undefined {
  if (!activityDetails) {
    return;
  }

  const position = activityDetails.staticInfo.position;
  const shift = 0.01;

  return {
    topLeft: {
      longitude: position.longitude.decimalDegrees - shift,
      latitude: position.latitude.decimalDegrees + shift,
    },
    bottomRight: {
      longitude: position.longitude.decimalDegrees + shift,
      latitude: position.latitude.decimalDegrees - shift,
    },
  };
}

export function getMapMarker(
  activityDetails: ActivityStaticData | undefined
): Marker | undefined {
  if (!activityDetails) {
    return;
  }

  const { latitude, longitude } = activityDetails.staticInfo.position;
  const ingredientId = activityDetails.staticInfo.ingredientId;

  const ticketType = activityDetails.staticInfo.typeOfHotel;
  const marker =
    ticketType === AccommodationType.Golf
      ? MarkerType.DetailsGolf
      : MarkerType.DetailsActivity;
  return {
    key: activityDetails.productCode,
    position: {
      latitude: latitude.decimalDegrees,
      longitude: longitude.decimalDegrees,
    },
    data: { ingredientId },
    useContentFormatter: marker,
  };
}

export function getMapMarkerFormatters(
  mapType: MapType.Static
): Partial<MarkerFormatter>;
export function getMapMarkerFormatters(
  mapType: MapType.Dynamic,
  mapTypeId: MapTypeId
): Partial<MarkerFormatter>;
export function getMapMarkerFormatters(
  mapType: MapType,
  mapTypeId?: MapTypeId
): Partial<MarkerFormatter> {
  switch (mapType) {
    case MapType.Static:
      return markerFormattersURL;
    case MapType.Dynamic:
      if (!mapTypeId) {
        throw new Error('mapTypeId is required for Dynamic maps');
      }
      return getMarkerFormattersHTML(mapTypeId);
    default:
      throw new Error('Invalid map type');
  }
}
